import React from 'react';

class ContactView extends React.Component {

  constructor(props) {
    super(props);

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete() {
    if (this.props.onDelete) {
      this.props.onDelete(this.props.contact);
    }
  }

  render() {

    const { contact, allowDelete } = this.props;

    return (
      <tr>
        <td>{contact.name}</td>
        <td>{contact.email}</td>
        <td>{contact.phone}</td>
        <td>
          {allowDelete && (<a className="icon-remove" title="remove" onClick={this.onDelete} >&#xe912;</a>)}
        </td>
      </tr>
    );
  }
}

export default ContactView;



// WEBPACK FOOTER //
// ./src/components/projects/ProjectContacts/ContactView.js